export default __webpack_public_path__ + "static/media/SevenWonders.da5fd56a2786238e6e2954cf6daec196.webp";